export default __webpack_public_path__ + "static/media/no-stopping.bade2da2.svg";